import React from "react";

import { containersStyles } from "./Styles";

const DialogContentContainer = ({children}) => {
    const styles = containersStyles();
    return(
        <div className={styles.dialogContentContainer}>
            {children}
        </div>
    )
}

export default DialogContentContainer